module.exports = __webpack_public_path__ + "fontawesome-webfont.svg?9f929e10596bc952edd962f2e41c119d";


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome/fonts/fontawesome-webfont.svg?v=4.7.0
// module id = 282
// module chunks = 0